import React from "react";
import { Grid } from "@material-ui/core/";
import Button from "@material-ui/core/Button";
import "./about.css";
import * as data from "../performance-tracker-template/data-toload.json";
import { Gauge } from "../visualisations/gauge";
import { Sunburst } from "../visualisations/sunburst";
import { BarChart } from "../visualisations/barchart";
import { useHistory } from "react-router-dom";
export const AboutPage: React.FC<{
  setAbout: React.Dispatch<React.SetStateAction<boolean>>;
}> = (props: { setAbout: React.Dispatch<React.SetStateAction<boolean>> }) => {
  const history = useHistory();

  const dataStyles: { [tab: string]: EnvTempStyles } = data.envTemplateStyles;

  return (
    <div>
      <h2>Green City Performance Tracker</h2>
      <Button
        onClick={() => {
          history.push("/login");
        }}
        className="button3"
      >
        Click here to participate
      </Button>
      <br></br>
      <p>
        In June 2019 <a href="">Southampton City Council</a> (SCC) announced an
        ambitions target for its city under the banner{" "}
        <a href="">Green City Charter</a> (GCC) and more recently declared a
        climate emergency (
        <a href="">
          many local authorities in the UK have declared a climate emergency
        </a>
        ). In addition to the City Council, the GCC was signed by other{" "}
        <a href="">entities in the city</a>, including institutions, businesses
        and charities. However, there are no specific indicators to measure the
        success or otherwise of commitments undertaken by the participants.
      </p>

      <p>
        The charter was created to assist Southampton City Council in its
        transition towards zero carbon making it a cleaner, greener and
        healthier city. The GCC has five main themes, summarised below (click on
        an icon to find out more).
      </p>

      <Grid
        container
        direction="row"
        spacing={1}
        justify="space-between"
        style={{
          marginTop: 10,
          marginBottom: 10,
          width: "100%",
          marginLeft: 0,
        }}
      >
        {Object.keys(dataStyles).map((tabName: string) => {
          return (
            <Grid
              item
              xs={2}
              style={{
                background: dataStyles[tabName].themeBackground,
                textAlign: "center",
                color: "white",
                borderBottomStyle: "solid",
              }}
              key={tabName}
            >
              <img src={dataStyles[tabName].img} style={{ width: "100px" }} />
              <div style={{ fontSize: 14 }}>
                {tabName}
              </div>
            </Grid>
          );
        })}
      </Grid>
      <p>
        In order to assess the GCC and its targets, a <b>Performance Tracker</b>{" "}
        has been developed by the Energy and Climate Change Division (ECCD) at
        the University of Southampton to provide a robust assessment of the GCC
        signatories under each of the five themes (criteria) of the GCC. The
        Tracker will enable an organisation to assess and quantify their present
        and future development in achieving their committed sustainability
        targets under the fives themes. Alongside this, the Tracker also
        provides a platform allowing parties to see and learn from the progress
        made by other GCC signatories.{" "}
      </p>

      <p>
        The Tracker measures performance across the five main GCC themes, which
        are sub-divided into 39 sub-themes (Fig.1). The weighting of each theme
        and sub-theme has been evaluated through a mathematical approach based
        on the Analytical Hierarchy Process (AHP) supported by input from
        selected experts in the field to arrive at a consensus in the weighting.
        All items are scored based on specific guidelines taking into account
        the size and type of organisation.
      </p>
    </div>
  );
};
